export const setTasks = (tasks, taskStatus) => ({
    type: 'SET_TASKS',
    tasks: tasks,
    taskStatus: taskStatus
});

export const setTaskMessages = (taskMessages) => ({
    type: 'SET_TASK_MESSAGES',
    taskMessages: taskMessages
});